import { ApolloClient, InMemoryCache, QueryOptions, gql } from "@apollo/client";
import { TClientGlobalVariables, TResultProduct } from "types";
import { TShopifyGraphqlResponse } from "types/shopify";
import { toast } from "react-toastify";
import * as consts from 'constants/constants';
import ProductVertical from "components/Product/ProductVertical";
// import productToSkuMap from '../ProductSkuMap.json';

// TODO only run this code if Magento is the active platform
// TODO: Get rid of Apollo/graphql-tag dependency to remove the 34.15KB (gzipped) penalty

const queryFn = () => gql`
  query prods($firstNum: Int, $prods: String) {
    products(first: $firstNum, query: $prods) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          handle
          title
          productType
          descriptionHtml
          options {
            name
            values
          }
          variants(first: 40) {
            edges {
              node {
                id
                title
                priceV2 {
                  amount
                  currencyCode
                }
                compareAtPriceV2 {
                  amount
                  currencyCode
                }
                selectedOptions {
                  name
                  value
                }
                image {
                  url
                  id
                }
                sku
                availableForSale
              }
            }
          }
        }
      }
    }
  }
`;

(window.compatioConfig?.shopify as TClientGlobalVariables)

class ShopifyHelper {
  static getVariantId = (encryptedID: string) => {
    let str = encryptedID;
    str = str.split('/')[str.split('/').length - 1];
    return str;
  }

  static getProductIdString = (merchantProductIDs: string[]) => {
    let query = merchantProductIDs.join(' OR id:');
    query = 'id:' + query;
    return query;
  }


  static convertGraphQLToCompatioFormat = (variantIds: string[], graphQLData: TShopifyGraphqlResponse) => {
    let productsVariants: {[x: string]: any} = {};
    graphQLData.data.products.edges.forEach(data => {
      const productID = this.getVariantId(data.node.id);

      const hasMultipleVariants = data.node.variants.edges.length > 1

      data.node.variants.edges
      .filter(prodVariant => variantIds.includes(this.getVariantId(prodVariant.node.id)))
      .forEach(prodVariant => {
        const variantID = this.getVariantId(prodVariant.node.id);
          if(!productsVariants.hasOwnProperty(productID)) {
            productsVariants[productID] = {
              [consts.RESULT_PRDT_NAME]: `${data.node.title}`,
              [consts.RESULT_PRDT_SKU]: productID,
              [consts.RESULT_PRDT_URL_IMAGE]: prodVariant.node.image === null
                ? 'https://cdn0.iconfinder.com/data/icons/symbols-add-on-2-vol-1/48/v-03-512.png'
                : prodVariant.node.image.url,
              [consts.RESULT_PRDT_OPTIONS]: []
            }
          }
          
          productsVariants[productID][consts.RESULT_PRDT_OPTIONS].push({
            [consts.RESULT_PRDT_SKU]: variantID,
            [consts.RESULT_PRDT_MODEL_NO]: prodVariant.node.sku,
            [consts.RESULT_PARENT_ID]: productID,
            variantTitle: prodVariant.node.title,
            [consts.RESULT_PRDT_NAME]: `${data.node.title}${hasMultipleVariants ? ` - ${prodVariant.node.title}` : ""}`,
            // productName: `${data.node.title}`,
            [consts.RESULT_PRDT_DESC]: `${data.node.descriptionHtml}`,
            // productHandle: `${data.node.handle}`,
            [consts.RESULT_PRDT_URL]: `${window.location.origin}/products/${data.node.handle}?variant=${variantID}`,
            [consts.RESULT_PRDT_URL_IMAGE]:
              prodVariant.node.image === null
                ? 'https://cdn0.iconfinder.com/data/icons/symbols-add-on-2-vol-1/48/v-03-512.png'
                : prodVariant.node.image.url,
            [consts.RESULT_PRDT_PRICE]: parseFloat(prodVariant.node.priceV2.amount),
            // compareAtPrice: parseFloat(
            //   prodVariant.node.compareAtPriceV2
            //     ? prodVariant.node.compareAtPriceV2.amount
            //     : ''
            // ),
            availableForSale: prodVariant.node.availableForSale,
            [consts.RESULT_PRDT_STOCK_STATUS]: prodVariant.node.availableForSale ? consts.STOCK_STATUSES.IN_STOCK : consts.STOCK_STATUSES.OUT_OF_STOCK
            // categoryName: data.node.productType,
            // currency: graphQLData.data.shop.currencyCode,
            // options: prodVariant.node.selectedOptions,
          })
      });
    });

    return Object.values(productsVariants);
  }

  static fetchProducts: <T extends (...args: any) => any>(merchantProductSkus: string[], callbackFn: T) => Promise<ReturnType<T>> = (
    merchantProductSkus, 
    callbackFn
  ) => {
    return new Promise((resolve, reject) =>{
      if(!window.compatioConfig?.shopify?.apiEndpointUrl)  {
          toast.error("Env error")
          // console.error("Shopify graphql suffix env not found", "Err 6")
          return
      }

      try{
        const client = new ApolloClient({
            uri: window.compatioConfig.shopify.apiEndpointUrl,
            cache: new InMemoryCache(),
            connectToDevTools: false,
        });

        const queryParams: QueryOptions = {
            query: queryFn(),
            variables: {
              firstNum: 100,
              prods: this.getProductIdString(merchantProductSkus)
              // prods: `id:7608048451759 OR id:8028603482287 OR id:8028603449519 OR id:8028603351215 OR id:8028603252911 OR id:7398080544943 OR id:7819565793455 OR id:7769356370095 OR id:7640549753007 OR id:7640548245679 OR id:8084949041351 OR id:8084949041351 OR id:6218694656199 OR id:6218672668871 OR id:7903292194991 OR id:7640541200559 OR id:7640539889839 OR id:6218357375175 OR id:7858647793839 OR id:7858555486383 OR id:7857364500655 OR id:7857278582959 OR id:7833668419759 OR id:7790709145775 OR id:7789562790063 OR id:7789560791215 OR id:7724639387823 OR id:7687316471983 OR id:7762795200687 OR id:7762795135151 OR id:7762794971311 OR id:7634119491759 OR id:7642023919791 OR id:7687316406447 OR id:7605432123567 OR id:7726381039791 OR id:7724601213103 OR id:7717558255791 OR id:7687314931887 OR id:7687314931887 OR id:7687314931887 OR id:7640538153135 OR id:7398080512175 OR id:7663516352687 OR id:7663516385455 OR id:7808961118407 OR id:7808961118407 OR id:7704091820207 OR id:7704092082351 OR id:7704092082351 OR id:7704092082351 OR id:7687315226799 OR id:7687315226799 OR id:7687314112687 OR id:7687314112687 OR id:7687314079919 OR id:7766594322631 OR id:7766587539655 OR id:7642024116399 OR id:7642024116399 OR id:7642024149167 OR id:7687314079919 OR id:7398080577711 OR id:7687315030191 OR id:7687315030191 OR id:7711139004591 OR id:7690046537903 OR id:7687316406447 OR id:7687316406447 OR id:7687314047151 OR id:7687314047151 OR id:7687314047151 OR id:7687313948847 OR id:7687313916079 OR id:7687313916079 OR id:7687313916079 OR id:7707974762671 OR id:7643589673135 OR id:7642024149167 OR id:7642024149167 OR id:7642024116399 OR id:7642024116399 OR id:7642023952559 OR id:7642023919791 OR id:7640540250287 OR id:7640536809647 OR id:7614621515951 OR id:7614621515951 OR id:7614621515951 OR id:7614621515951 OR id:7614620139695 OR id:7614620139695 OR id:7614620139695 OR id:7614609522863 OR id:7614609064111 OR id:7614608703663 OR id:6992327245999 OR id:6992314040495 OR id:7608050778287 OR id:7608050778287 OR id:7608048451759 OR id:7608048451759 OR id:7608048451759 OR id:7603818954927 OR id:7600520560815 OR id:7600520036527 OR id:7597795410095 OR id:7597103874223 OR id:7582211834031 OR id:7580907536559 OR id:7575808868527 OR id:7571998441647 OR id:4644317397076 OR id:7560018198703 OR id:7544832196783 OR id:7392900645039 OR id:7343192703151 OR id:7118246117551 OR id:6992314040495 OR id:6749769334959 OR id:6749769334959 OR id:7547727839407 OR id:7474245173423 OR id:6992326721711 OR id:7391035785391 OR id:7391027495087 OR id:7391027495087 OR id:7391027495087 OR id:7391027495087 OR id:7391027429551 OR id:7391027429551 OR id:7391027429551 OR id:7391027429551 OR id:7377404330159 OR id:7377404330159 OR id:7377404330159 OR id:7453517021359 OR id:7453517021359 OR id:7174889373871 OR id:7531203330223 OR id:7531203330223 OR id:7479858331823 OR id:7479858331823 OR id:7479858331823 OR id:7479858331823 OR id:7475032359087 OR id:7475004342447 OR id:7475003031727 OR id:6080363462831 OR id:7474245173423 OR id:7474245107887 OR id:7392901562543 OR id:7392901300399 OR id:7392900743343 OR id:7498046767279 OR id:7392900579503 OR id:7392900939951 OR id:7392900776111 OR id:7414745530543 OR id:7392901628079 OR id:7392901660847 OR id:7392901497007 OR id:7392901529775 OR id:7392901136559 OR id:7392900972719 OR id:7392901071023 OR id:7392901234863 OR id:7392901202095 OR id:7392901431471 OR id:7392901365935 OR id:7392900841647 OR id:7392900874415 OR id:7392900612271 OR id:7392901333167 OR id:7392900907183 OR id:7392901103791 OR id:7398080348335 OR id:7398080413871 OR id:7398080610479 OR id:7398080446639 OR id:7398080479407 OR id:7466590208175 OR id:7466590240943 OR id:7466587226287 OR id:7392901005487 OR id:7423651610799 OR id:7410358157487 OR id:7410358223023 OR id:7453517086895 OR id:7453517086895 OR id:7378279039151 OR id:7378279039151 OR id:7378279039151 OR id:7378279039151 OR id:6080363462831 OR id:6080363462831 OR id:6992326721711 OR id:6992308830383 OR id:7392901464239 OR id:7392900677807 OR id:7218306941103 OR id:7424268959919 OR id:7424268959919 OR id:7435907301551 OR id:7435907301551 OR id:7435907301551 OR id:7435905958063 OR id:7435905958063 OR id:7435905958063 OR id:7435906711727 OR id:7435906711727 OR id:7435906711727 OR id:7391041618095 OR id:7391041618095 OR id:7391041618095 OR id:7391035785391 OR id:7391043551407 OR id:7391043551407 OR id:7391043551407 OR id:7392904609967 OR id:7392904577199 OR id:7392903233711 OR id:7392903168175 OR id:7392903135407 OR id:7392903102639 OR id:7392903069871 OR id:7392903037103 OR id:7392903004335 OR id:7392902938799 OR id:7392902906031 OR id:7392902873263 OR id:7392902840495 OR id:7392902807727 OR id:7392902774959 OR id:7392902742191 OR id:7392902676655 OR id:7392902643887 OR id:7392902611119 OR id:7392902578351 OR id:7392902512815 OR id:7392902480047 OR id:7392902414511 OR id:7392902381743 OR id:7392902348975 OR id:7392902316207 OR id:7392902283439 OR id:7392902250671 OR id:7392902217903 OR id:7392902185135 OR id:7392902152367`
            }
        }

        queryParams.context = {headers: {}}

        if(window.compatioConfig?.compatibleProducts?.[consts.CMPT_CONF_STORE]) {
          queryParams.context.headers.store = window.compatioConfig?.compatibleProducts?.[consts.CMPT_CONF_STORE]
        }
        if(window.compatioConfig.shopify.shopifyStorefrontAccessToken) 
          queryParams.context.headers['X-Shopify-Storefront-Access-Token'] = window.compatioConfig.shopify.shopifyStorefrontAccessToken
            
        client?.query(queryParams)
        .then((res) => {
            resolve(callbackFn(res))
        })
        .catch((err) => {
            // console.error(err)
            reject(err)
        })
      }
      catch(err){
          // console.error(err)
          reject(err)
      }
    })
  }

  static getProductsBySkus: (merchantProductSkus: string[], variantids: string[]) => Promise<ReturnType<typeof this.convertGraphQLToCompatioFormat>> = (
    merchantProductSkus: string[],
    variantIds
    ) =>{
      return this.fetchProducts(merchantProductSkus, (res) => this.convertGraphQLToCompatioFormat(variantIds, res))
  }

  static getCartProducts:(products: TResultProduct[]) => Promise<TResultProduct[]> = async (
    products
  ) => {
    const graphQLData: TShopifyGraphqlResponse = await this.fetchProducts(products.map(product => product[consts.RESULT_PARENT_ID]), (res) => res)
    const productSkus = products.map(product => product[consts.RESULT_PRDT_SKU])

    const graphQlProducts: any = {}

    graphQLData.data.products.edges.forEach(data => {
    const hasMultipleVariants = data.node.variants.edges.length > 1

      const productID = this.getVariantId(data.node.id);
      data.node.variants.edges.forEach(prodVariant => {
        const variantID = this.getVariantId(prodVariant.node.id);
        if(!productSkus.includes(variantID)) return null

        graphQlProducts[variantID] = {
          [consts.RESULT_PRDT_SKU]: variantID,
          [consts.RESULT_PARENT_ID]: productID,
          [consts.RESULT_PRDT_MODEL_NO]: prodVariant.node.sku,
          [consts.RESULT_PRDT_NAME]: `${data.node.title}${hasMultipleVariants ? ` - ${prodVariant.node.title}` : ""}`,
          [consts.RESULT_PRDT_DESC]: `${data.node.descriptionHtml}`,
          [consts.RESULT_PRDT_URL]: `${window.location.origin}/products/${data.node.handle}?variant=${variantID}`,
          [consts.RESULT_PRDT_URL_IMAGE]:
            prodVariant.node.image === null
              ? 'https://cdn0.iconfinder.com/data/icons/symbols-add-on-2-vol-1/48/v-03-512.png'
              : prodVariant.node.image.url,
          [consts.RESULT_PRDT_PRICE]: parseFloat(prodVariant.node.priceV2.amount),
          [consts.RESULT_PRDT_STOCK_STATUS]: prodVariant.node.availableForSale ? consts.STOCK_STATUSES.IN_STOCK : consts.STOCK_STATUSES.OUT_OF_STOCK,
        }
      })
    })
    return graphQlProducts
  }
}

// TODO: Refactor this to avoid using globals
export default ShopifyHelper;

